export const environment = {
  production: false,
  // TEMPORARY: pointed at the LIVE VPS API so `npm start` can be tested without
  // running the backend locally. The API allows http://localhost:4200 via the
  // hardcoded origins in the backend's src/server.js.
  //
  // ⚠️ This is PRODUCTION DATA. Creating, editing or deleting anything here
  // changes the real store. Restore the local URL below when done:
  //   apiUrl: 'http://localhost:3001/api/jewellery'
  apiUrl: 'https://api.vinayaka.staywisely.in/api/jewellery'
};
